import { Component, OnChanges, OnInit, OnDestroy, ViewEncapsulation, ViewChild } from '@angular/core';
import 'style-loader!./registration.component.scss';
import { AlertService } from 'app/theme/services/alert.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { User, Task, Copy } from 'app/theme/models/user.model';
import { UserService } from 'app/theme/services/user.service';
/** parts  */
import { ModuleComponent } from 'app/theme/components/slide1/slide1.component';
import { VerificationComponent } from 'app/theme/components/slide2/slide2.component';
import { InterestComponent } from 'app/theme/components/slide4/slide4.component';
import { CreateBennetAccountComponent } from 'app/theme/components/slide3/slide3.component';
import { ChannelService } from 'app/theme/services/channel.service';
import { MatIconRegistry, MatStepper } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { LanguageService } from 'app/theme/services/language.service';
import { CustomerService } from 'app/theme/services/customer.service';
import { ThemeSpinnerService } from 'app/theme/services/themeSpinner.service';
import { DialogService } from 'app/theme/services/dialog.service';
import { ICacheStatusResponse  } from 'app/theme/models/response';


@Component({
	selector: 'registration-module',
	templateUrl: './registration.component.html',
	encapsulation: ViewEncapsulation.None,

})
export class RegistrationComponent implements OnChanges, OnInit, OnDestroy {
	@ViewChild(ModuleComponent) module;
	@ViewChild(VerificationComponent) verification;
	@ViewChild(CreateBennetAccountComponent) registration;
	@ViewChild(InterestComponent) interest;
	// requests 
	ActivateRegistration: boolean;
	ActivateStepper: boolean;
	//Registrazione info 
	User: User = new User();
	Labels;
	selectedIndex: number;
	selectedStep: number;
	asset: string;
	//email = "servizio.clienti@bennet.com";
	phone = "800 23 66 38";
	urlCustomerCare = "www.bennet.com/customerCare";
	alerts;
	prefix;
	activedMaintenanceStibo: boolean = false;
    activedMaintenanceDate: string = '';
	//steps 
	Submitted: boolean
	Verified: boolean
	CreatedBennetOrSkipped: boolean
	ChosenPDV: boolean
	Finished: boolean
	hasAccount: boolean
	mtx: boolean;
	createdAccount: boolean;
	// Router info 
	sharedData: any;
	ExistedUser: User = new User();
	sub: Subscription;
	task: Task;
	nexturl
	source
	public constructor(
		protected _spinnerService: ThemeSpinnerService,
		protected _alertService: AlertService,
		protected _userService: UserService,
		protected _channelService: ChannelService,
		protected _langService: LanguageService,
		protected _customerService: CustomerService,
		protected _dialogService: DialogService,
		protected router: Router,
		protected regIcon: MatIconRegistry,
		protected sinitizer: DomSanitizer,
	) {

		//regIcon.addSvgIcon("email", sinitizer.bypassSecurityTrustResourceUrl('./assets/icon/icon_email.svg'))
		regIcon.addSvgIcon("phone", sinitizer.bypassSecurityTrustResourceUrl('./assets/icon/icon_phone.svg'))
		regIcon.addSvgIcon("urlCC", sinitizer.bypassSecurityTrustResourceUrl('./assets/icon/icon_world.svg'))

	}

    //CR ACCESSIBILITà GESTIONE AUTOCOMPLETE START
    ngAfterViewInit() {
        const fields = ['cap', 'city', 'province', 'address', 'civico','via'];
        const disableForAll = this.source === 'tablet' || this.source === 'totem' || this.source === 'tablet-new' || this.source === 'totem-new';
        
        if (disableForAll) {
            // Converte NodeList in un array e applica la funzione
            Array.from(document.querySelectorAll('input')).forEach((input: HTMLInputElement) => {
            this.disableAutocomplete(input.id); // Usa l'id se disponibile
            });
        
        } else {
            // Disattiva solo per i campi specificati
            fields.forEach(field => this.disableAutocomplete(field));
        }
        }
      
    
        private disableAutocomplete(elementId: string): void {
            const inputElement = document.getElementById(elementId) as HTMLInputElement;
            let sottostringa = "mat-";        

            if (!elementId.toLowerCase().includes(sottostringa.toLowerCase())) {
                if (inputElement) {
                    // Disattiva tutti gli attributi legati all'autocomplete
                    inputElement.setAttribute('autocomplete', 'new-password'); // Alternativa più efficace a "off"
                    inputElement.setAttribute('autocorrect', 'off');
                    inputElement.setAttribute('autocapitalize', 'off');
                    inputElement.setAttribute('spellcheck', 'false');
                    
                    // Cambia dinamicamente il nome e l'ID per evitare suggerimenti memorizzati
                    const newName = elementId + '_' + new Date().getTime();
                    inputElement.setAttribute('name', newName);
                    inputElement.setAttribute('id', newName);
        
                    // Disattiva la gestione automatica degli indirizzi di Chrome e password manager
                    inputElement.setAttribute('data-lpignore', 'true'); // LastPass
                    inputElement.setAttribute('data-form-type', 'other');
                    inputElement.setAttribute('aria-autocomplete', 'none');
                
                    // Nasconde suggerimenti tramite CSS inline
                    // inputElement.style.setProperty('display', 'inline-block', 'important');
                    inputElement.style.setProperty('position', 'relative', 'important');
                    inputElement.style.setProperty('z-index', '9', 'important'); //Abbastanza da sovrapporre i campi non abbastanza da sovrapporre il resto
                    
                    // Ritarda la modifica dell'ID per "ingannare" il browser
                    setTimeout(() => {
                        inputElement.setAttribute('id', elementId);
                    }, 1000);  
                }              
            }
        }  
    //CR ACCESSIBILITà GESTIONE AUTOCOMPLETE END

	/* --------------------- */
	public ngOnChanges() { }
	public ngOnDestroy() { }
	public ngOnInit() {
		//console.log("ngOnInit");
		debugger;
		console.timeEnd("fromAPPtoREG");
		// steps controller   
		this.Submitted = false;
		this.Verified = false;
		this.CreatedBennetOrSkipped = false;
		this.ChosenPDV = false;
		this.Finished = false;
		this.selectedIndex = 0;
		this.selectedStep = 0;
		this.hasAccount = false;
		this.mtx = false;
		this.createdAccount = true;
		this._userService.setUser(new User());
		this._langService.translatePageIndex(3)
			.subscribe((mylabels) => {
				this.Labels = mylabels;
				this.asset = (this.Labels.language = "italian") ? "Hai bisogno di assistenza ? " : "Do you need assestance ? ";
			})
		this._channelService.getTask()
			.subscribe((task: Task) => {
				this.task = task;
				if (task == Task.RichiediBC) {
					this.ActivateStepper = true;
				} else {
					this.ActivateRegistration = true;
				}
			})
		this._channelService.getSource()
			.subscribe((source: string) => {
				if (source) {
					this.source = source;
				}
			})
		// subscribe user 
		this._userService.getUser()
			.subscribe((user: User) => {
				if (user)
					this.User = Copy(user);
			})
		this._userService.getPrefixNumber()
			.subscribe((prefix: string) => {
				this.prefix = prefix;
			})

		this._langService.subscribeAlerts()
			.subscribe((alerts) => {
				if (alerts) {
					this.alerts = alerts;
				}
			})
		this._channelService.getNextUrl()
			.subscribe((nexturl) => {
				this.nexturl = nexturl;
			})
			this._customerService.CacheStatus( )
			.then((data: ICacheStatusResponse) => {
				 
				 
				if(data.maintenanceActived=== 'Y'   ){
					this.activedMaintenanceDate=data.maintenanceActivedDate;
					this.activedMaintenanceStibo=true;
					if (this.source == "tablet-new" || this.source == "tablet") {
						let refDialog =this._alertService.showModalAlertWarning(this.Labels.stiboBCMaintenance, `
						<div class='text-center'>
						${this.Labels.stiboBCMaintenance1}<br><br>
						${this.Labels.stiboBCMaintenance2}<br>
						</div>
						`, null,'X');
					}
					 
				}
				
				 
	
			}).catch((error) => {
				//console.error(error);
				//this._router.navigate([])
				if (this.source == 'app') {
					//console.log("chiamata script KO GetInfoUser");
					self.postMessage(JSON.stringify({ "type": "KO", payload: { "username": "", "password": "", "message": this.alerts.alert_32 } }), '*');
				}
				 let refDialog =this._alertService.showModalAlertWarning('', `
					<div class='text-center'>
					${this.alerts.alert_32}
					</div>
					`, null,'X');
 			})
		this.adjustAsset();
	}

	setHasAccount(hadAccount) {
		//	console.log(hadAccount)
		this.hasAccount = hadAccount;
	}
	/**
	adjustAsset() {
		if (this.source == 'app' || this.source == 'drive-new' || this.source == 'instacook' || this.source == 'tablet') {

			var resize = () => {
				let widthWindow = window.innerWidth;
				let widthAsset = $("#asset").outerWidth();
				let left = (widthWindow - widthAsset) / 2;
				$("#asset").css('left', left);
			}
			var toggle = () => {
				$('#asset_content').slideToggle();
			}
			$("#asset").ready(() => {
				resize();
				toggle();
				$(window).resize(() => resize());
				$("#asset_title").on('click', () => toggle())
				$("#asset").css('visibility', 'visible');
			})
		}
	}*/

	adjustAsset() {
    if (this.source == 'app' || this.source == 'drive-new' || this.source == 'instacook' || this.source == 'tablet') {

        var resize = () => {
            let widthWindow = window.innerWidth;
            let widthAsset = $("#asset").outerWidth();
            let left = (widthWindow - widthAsset) / 2;
            $("#asset").css('left', left);
        }
        var toggle = () => {
            $('#asset_content').slideToggle();
        }

        $("#asset").ready(() => {
            resize();
            toggle();
            $(window).resize(() => resize());

            // Aggiungi tabindex per accessibilità con la tastiera
            $("#asset_title").attr("tabindex", "5");

            // Gestisci il click con il mouse
            $("#asset_title").on('click', () => toggle());

            // Gestisci la tastiera (Enter e Space)
            $("#asset_title").on('keydown', (event) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault(); // Previene lo scrolling quando si preme Space
                    toggle();
                }
            });

            $("#asset").css('visibility', 'visible');
        });
		}
	}

	onSubmitModule(stepper: MatStepper): void {
		//debugger;
		//console.log("onSubmitModule");
		if (this.mtx)
			return;
		this.mtx = true;
		this._spinnerService.show();
		this.module.onModuleSubmit()
			.then(() => {
				this.Submitted = true;
				setTimeout(() => {
					this.selectedIndex = 1;
					this.selectedStep = 1;
					this.mtx = false;
				}, 500);
				this._spinnerService.hide();
			})
			.catch((error = { type: "SERVER", title: "", content: "ERROR", redirect: "", btn: "X" }) => {
				this.mtx = false;
				//debugger;
				switch (error.type) {
					case "message":
						this._alertService.showModalAlertWarning(error.title, error.content, error.redirect, 'X')
						break;
					case "SERVER":
						this._alertService.showModalAlertWarning(error.title, error.content, error.redirect, 'X')
						break;
					case "action":
						this._alertService.showModalAlertWarning(error.title, error.content, error.redirect, 'X')
						break;
					case "anonimo":
						//this._alertService.showModalConfirm(this.Labels.exit, error.content, this.Labels.exit, 'X')
						break;
					default:
						break;
				}
				//	console.error("on submit error "+error);
				this._spinnerService.hide();
			})
	}
	onSubmitVerification(stepper: MatStepper) {
		//console.log("onSubmitVerification");
		if (this.mtx)
			return;
		this._spinnerService.show();
		this.mtx = true;
		this.verification.onVerifyCodice()
			.then(() => {
				this.Verified = true;
				setTimeout(() => {
					this.selectedIndex = 2;
					if (this.hasAccount) {
						this.CreatedBennetOrSkipped = true;
						this.interest.getSalesPoint();
						this.interest.getFavoriteMethod();
						setTimeout
						this.selectedIndex = 3;
					}
					this.selectedStep = 2;
					this.mtx = false;
				}, 500);
				this._spinnerService.hide();
			})
			.catch((error = { type: "", content: "", title: "", btn: "" }) => {
				console.error(error)
				switch (error.type) {
					case "warning":
						this._alertService.showModalAlertWarning(error.title, error.content, null, 'X');
						break;
					case "SERVER":
						this._alertService.showModalAlertWarning(error.title, error.content, null, 'X');
						break;
					default:
						break;
				}
				this.mtx = false;
				this._spinnerService.hide();
			})

	}
	onSubmitRegistration(stepper: MatStepper) {
		//console.log("onSubmitVerification");
		//debugger;
		if (this.mtx)
			return;
		this.mtx = true;
		this._spinnerService.show();
		this.registration.onSubmitBennetAccountORonSkip()
			.then(() => {
				this.CreatedBennetOrSkipped = true;
				this.interest.getSalesPoint();
				this.interest.getFavoriteMethod();
				setTimeout(() => {
					this.selectedIndex = 3;
					this.selectedStep = 3;
					this.mtx = false;
				}, 500);
				this._spinnerService.hide();

			})
			.catch((error = { content: "", title: "", btn: "" }) => {
				this.mtx = false;
				this._alertService.showModalAlertWarning(error.title, error.content, null, 'X');

				this._spinnerService.hide();
			})

	}
	onSubmitInterests(stepper: MatStepper) {
		//console.log("onSubmitInterests")
		if (this.mtx)
			return;
		this.mtx = true;
		this._spinnerService.show();
		this.interest.onSubmitBennetClub()
			.then(() => {
				this._customerService.SaveCustomer(this.User, this.prefix, this.task,this._userService.customerid,this._userService.key)
					.then(() => {
						this.ChosenPDV = true;
						this.Finished = true;
						setTimeout(() => {
							this.selectedIndex = 4;
							if (this.hasAccount)
								this.selectedStep = 3;
							else
								this.selectedStep = 4;
							this.mtx = false;
						}, 100);
						this._spinnerService.hide();
					}).catch((error) => {
						this.mtx = false;
						this._alertService.showModalAlertWarning("", this.alerts.alert_32, null, 'X');
						this._spinnerService.hide();
						if (this.source == 'app') {
							//console.log("chiamata script KO SaveCustomer");
							self.postMessage(JSON.stringify({ "type": "KO", payload: { "username": "", "password": "", "message": this.alerts.alert_32 } }), '*');
						}
					})
			})
			.catch((error = { content: "", title: "", btn: "" }) => {
				if (this.source == 'app') {
					//console.log("chiamata script KO");
					self.postMessage(JSON.stringify({ "type": "KO", payload: { "username": "", "password": "", "message": this.alerts.alert_32 } }), '*');
				}
				this.mtx = false;
				this._alertService.showModalAlertWarning(error.title, error.content, null, 'X');
				this._spinnerService.hide();
			})
	}
	onRedirectNextUrl() {
		//debugger;
		//console.log("onRedirectNextUrl")
		//console.log(this.nexturl);
		var urldec = decodeURIComponent(this.nexturl);
		var concat = "?";
		if (this.nexturl) {
			if (urldec.indexOf("?") !== -1) concat = "&";
		}
		if (this.source == 'tablet' || this.source == 'totem' || this.source == 'tablet-new' || this.source == 'totem-new')
			this.router.navigate(['pages', 'registrazione'])
		else if (this.source == 'drive-new' || this.source == 'bennet-new' || this.source == 'veronesi' || this.source == 'app' || this.source == 'instacook')
			this._channelService.getNextUrl()
				.subscribe((nexturl) => {
					if (this.source == 'app') {
						//console.log("chiamata script END");
						this.logEvent("sign_up");
						if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
							self.postMessage(JSON.stringify({ "type": "END", payload: { "username": this.User.account.email, "password": this.User.account.password } }), '*');
							document.body.classList.remove('modal-open');
							(<any>window).ReactNativeWebView.postMessage('closeWebView');
						}
						else  self.postMessage(JSON.stringify({ "type": "END", payload: { "username": this.User.account.email, "password": this.User.account.password } }), '*');
 					} else {
						//window.location.replace(decodeURIComponent(nexturl + '?username=' + this.User.account.email || ""))
						window.top.location.href = decodeURIComponent(nexturl + concat + 'username=' + this.User.account.email + "&registrationSuccess=true" || "")
					}

				})
		else
			this._channelService.getNextUrl()
				.subscribe((nexturl) => {
					window.location.replace(decodeURIComponent(nexturl + concat + 'username=' + this.User.account.email + "&registrationSuccess=true" || ""))
					//window.top.location.href = decodeURIComponent(nexturl + '?username=' + this.User.account.email || "")
				})
	}
	onSee() {
		//console.log(this.User);
	}
	onExit() {
		//console.log("onExit")
		if (this.selectedIndex == 0 && !this.activedMaintenanceStibo) {
			let refDialog = this._alertService.showModalConfirm(this.Labels.exit, this.alerts.alert_21, this.Labels.exit, 'X')
			refDialog.result
				.then(data => {
					this.ActivateStepper = false;
					this.ActivateRegistration = true;
					if (this.source == 'app') {
						if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
							self.postMessage(JSON.stringify({ "type": "CLOSE", payload: { "username": "", "password": "" } }), '*');
							document.body.classList.remove('modal-open');
							(<any>window).ReactNativeWebView.postMessage('closeWebView');
						}
						else  self.postMessage(JSON.stringify({ "type": "CLOSE", payload: { "username": "", "password": "" } }), '*');
					}

				})
				.catch(data => {

				})
		}
		else if (this.selectedIndex == 0 &&  this.activedMaintenanceStibo) {
			window.top.location.reload();
		}
		else {
			let SelectedIndex = {
				previouslySelectedIndex: this.selectedIndex,
				selectedIndex: (this.selectedIndex - 1)
			}
			this.onChangeSelectedIndex(SelectedIndex);
		}

	}
	onChangeSelectedIndex(SelectedIndex) {
		//console.log("onChangeSelectedIndex "+SelectedIndex)

		if (SelectedIndex.previouslySelectedIndex > SelectedIndex.selectedIndex) {
			switch (SelectedIndex.selectedIndex) {
				case 0:
					this.selectedIndex = 0;
					this.Submitted = false;
					this.Verified = false;
					this.CreatedBennetOrSkipped = false;
					this.ChosenPDV = false;
					this.Finished = false;
					break;
				case 1:
					this.selectedIndex = 1;
					this.Verified = false;
					this.CreatedBennetOrSkipped = false;
					this.ChosenPDV = false;
					this.Finished = false;
					break;
				case 2:
					this.selectedIndex = 2;
					this.CreatedBennetOrSkipped = false;
					this.ChosenPDV = false;
					this.Finished = false;
					break;
				case 3:
					this.selectedIndex = 3;
					this.ChosenPDV = false;
					this.Finished = false;
					break;
			}
			this.selectedStep = this.selectedIndex;
		}
	}
		logEvent(name: string, params?: Element) {
			if (!name) {
				return;
			}
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && this.source == 'app') {
				// Call Android interface or  iOS interface
				var message = {
					command: 'logEvent',
					name: name,
					parameters: params
	
				};
				console.log(message);
				self.postMessage(JSON.stringify(message), '*');
	
			} else {
				// No Android or iOS interface found
				console.log("No native APIs found.");
			}
		}

}






// WEBPACK FOOTER //
// ./src/app/pages/registration/registration.component.ts